import { useMutation } from '@tanstack/react-query';
import { SelfServiceSessionService } from '../../generated';

interface RequestSelfServiceSessionProps {
  jobsiteId: string | undefined;
}

export function useRequestSelfServiceSession() {
  return useMutation({
    mutationFn: async ({ jobsiteId }: RequestSelfServiceSessionProps) => {
      if (!jobsiteId) throw new Error('jobsiteId is required');
      const response = await SelfServiceSessionService.selfServiceSessionControllerRequestSelfServiceSession({
        path: {
          jobsiteId,
        },
      });

      if (response.data !== undefined) {
        return response.data;
      }

      throw (response as any).error || new Error(response.response?.statusText || 'Unknown error');
    },
  });
}
